// extracted by mini-css-extract-plugin
export default {"spriteAnimation":"plumAnimation_spriteAnimation__mBaJJ","frame":"plumAnimation_frame__D1wbz","visible":"plumAnimation_visible__nXfC5","hidden":"plumAnimation_hidden__naZx+"};